define('SageDotCom/DataLayer/Events/searchSelection',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function SearchSelectionEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "search_int_select"; // overwrite name
    }

    SearchSelectionEvent.prototype = Object.create(EventBase.prototype);

    SearchSelectionEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, searchTerm, searchFacets, label, action, name, resultPage) {
        var eventName = name || this.getName();
        var eventAction = action || "search selection";
        var eventData = {
            'event_name': eventName,
            'event_non-int': "0",
            'event_category': "search",
            'event_action': eventAction
        }

        if (scope) {
            var lbl = label || $(scope).text() || $(scope).val() || "";
            var id = $(scope).closest("[id]").attr("id");
            var href = $(scope).attr("href");
            var page = resultPage || href;
            var location = this.getLocation(scope);
            var facets = searchFacets || location;
            eventData = $.extend(eventData, {
                'event_label': this.stripHtml(lbl.trim()), // strip any html
                'event_name_level_1': id,
                'event_name_level_2': page,
                'event_name_level_3': searchTerm,
                'event_name_level_4': facets
            });
        }

        return eventData;
    }

    return new SearchSelectionEvent();
});
